import { AuthProvider } from '@doss/common-all'
import { appSdkAssetBaseFor } from '@doss/guest-frame/app-sdk'

// Production Firebase Config
const firebaseConfig = {
  apiKey: 'AIzaSyCZROr_4S2zCL6Q8PM05nyTxL_yRNX0Vsg',
  authDomain: 'production-396017.firebaseapp.com',
  databaseURL: 'https://production-396017-default-rtdb.firebaseio.com',
  projectId: 'production-396017',
  storageBucket: 'production-396017.appspot.com',
  messagingSenderId: '864593434442',
  appId: '1:864593434442:web:562a6f7a6e322f0f5b53b3',
  measurementId: 'G-JMN75JNS6X',
}

export const config = {
  adminBaseUrl: 'admin.doss.com',
  apiBaseUrl: 'api.doss.com',
  webBaseUrl: 'app.doss.com',
  webhooksBaseUrl: 'webhooks.doss.com',
  docuforgeBaseUrl: 'docuforge.doss.com',
  appSdkAssetBase: appSdkAssetBaseFor('production'),
  sentryUrl:
    'https://819f3f17d2ab4a958e31abc91fdfa8b1@o4504896410025984.ingest.sentry.io/4505035079483392',
  logrocketId: 'l3k4df/doss-web',
  protocol: 'https',
  websocketProtocol: 'wss',
  firebaseConfig,
  jitsuHost: 'https://jitsu.doss.com',
  jitsuWriteKey: 'IBU8vGzQQikIfRXzAQlFaL1RSy0AhcLF:yXpCpJppIRBg20ZaW4WHMeQWsIRmFhGU',
  analyticsJitsuEnabled: true,
  perfTelemetryEnabled: true,
  stripePublishableKey:
    'pk_live_51LoEBoIr04lJNUdfujBqaV2VnPBCgH4YDnGl195sFqL34l1BQ7wTDgHzp9ZhJdvBeQGTgC0KjtcNsPRdywNPsYQ800RHHwKltJ',
  gcpServiceAccountEmail: '864593434442-compute@developer.gserviceaccount.com',
  stripeStagingPublishableKey:
    'pk_test_51LoEBoIr04lJNUdf2K625ZzB9nCgCsGHbqV16AnqzvpCXT63ggox6GgwetYTBHgUeJwFXY9zuQL3TdyCNHrhr51f00W38Np6C3',
  // Auth provider: Defaults to 'workos', legacy is 'firebase' can be overridden with VITE_AUTH_PROVIDER in Vercel
  authProvider: (import.meta.env.VITE_AUTH_PROVIDER || 'workos') as AuthProvider,
  loopReturnsInstallUrl:
    'https://admin.loopreturns.com/third-party-integration/install/c986e3b5-6de4-47ce-9b67-cdc393b17348',
}
